/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";

import useDocumentTitle from "../../../utils/useDocumentTitle";

import CancelIcon from "@material-ui/icons/Cancel";

import styles from "./SessionsOverview.module.scss";
import SortableTable from "./SortableTable";

import PageContent from "../../../components/PageContent";
import Section from "../../../components/Section";
import SectionTitle from "../../../components/SectionTitle";
import { Tab, Tabs } from "../../../components/Tabs";
import { DashboardLayout } from "../../../layouts/DashboardLayout";
import { getQueryVariable } from "../../../utils/getQueryParam";

import { Metric, MetricsWrapper } from "../../../components/Metric";
import ReminderPopUp from "../../../components/ReminderPopUp";

import { useTranslation } from "react-i18next";
import { TableConfig } from "../../../config/Config";
import { IsCampaignAdmin, IsCoach } from "../../../config/Roles";
import AuthApi from "../../../context/AuthApi";
import { useCampaign } from "../../../context/campaign";
import { useNotification } from "../../../context/notification";
import { apiRequest } from "../../../utils/api";
import { getLocalValue } from "../../../utils/auth";

export function SessionsTeamOverview(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const Auth = useContext(AuthApi);
  const { id } = useParams();
  const history = useHistory();
  const tableHeader = [
    {
      name: "session_ongoing_upcoming_date",
      label: t("sessionList.upcomingSession"),
      width: "10%",
    },
    {
      name: "session_datetime",
      label: t("sessionList.sessionDateTime"),
      width: "10%",
    },
    { name: "session_id", label: "Session ID", width: "8%" },
    { name: "", label: t("sessionList.time"), width: "8%" },
    {
      name: "type",
      label: t("sessionList.type"),
      width: "9%",
    },
    { name: "subject", label: t("sessionList.subjects"), width: "14%" },
    { name: "coachee_fullname", label: t("sessionList.name"), width: "13%" },
    {
      name: "coachee_employee_id",
      label: t("sessionList.employeeID"),
      width: "10%",
    },
    { name: "status", label: t("sessionList.status"), width: "18%" },
  ];

  const { selectedCampaign } = useCampaign();
  const { addNotification } = useNotification();
  const [teamData, setTeamData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [uid] = useState(getLocalValue("uid"));
  const [perPage, setPerPage] = useState(TableConfig.resultPerPage);
  const [sessionPendingList, setSessionPendingList] = useState(0);

  useEffect(() => {
    // fetch from getSessionDetails api
    async function fetchData() {
      setIsLoading(true);
      const response = await apiRequest.get(
        `/api/getOngoingTeamSession?uid=${uid}&campaign_id=${selectedCampaign}`
      );

      if (response.status === 200) {
        const data = response.data.data;
        let filterData = data;
        if (id) {
          filterData = filterData.filter(
            item => item.coachee_fullname === getQueryVariable("name")
          );
        }
        setTeamData(filterData);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }
      setIsLoading(false);
    }
    fetchData();
  }, [selectedCampaign]);

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("sessionList.title")}</SectionTitle>
            {Auth.isCoach && !Auth.isCampaignCoord && (
              <Tabs>
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  defaultTab={true}
                />
                <Tab
                  label={"personal"}
                  tabName={t("tabs.personal")}
                  linkTo={`/sessions/personal`}
                />
              </Tabs>
            )}

            {Auth.isCampaignCoord && (
              <Tabs>
                <Tab
                  label={"campaign"}
                  tabName={t("tabs.campaign")}
                  linkTo={`/sessions/campaign`}
                />
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  defaultTab={true}
                />
              </Tabs>
            )}
            {(IsCoach() || IsCampaignAdmin()) && <ReminderPopUp />}
            {!id && (
              <MetricsWrapper>
                <Metric
                  label={t("sessionList.totalSessionPending")}
                  data={sessionPendingList}
                />
              </MetricsWrapper>
            )}

            {id && (
              <div className={`${styles.status} ${styles.tag}`}>
                {getQueryVariable("name")}
                <CancelIcon
                  onClick={() => {
                    history.push("/sessions/teams/");
                  }}
                />
              </div>
            )}

            {teamData && (
              <SortableTable
                tableData={teamData}
                tableHeader={tableHeader}
                isPersonal={false}
                perPage={perPage}
                setPerPage={setPerPage}
                subjectParam={`coach_id=${uid}`}
                onUpdatingFilter={count => {
                  setSessionPendingList(count);
                }}
              />
            )}
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}